import { CommonAPI } from "../Client";

// export const getWebsiteInfoAPI = (payload) => {
//   return CommonAPI.get(`/website/${payload}`)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       throw error.response;
//     });
// };

export const getWebsiteInfoAPI = (payload) => {
  return CommonAPI.get(`/website/${payload}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteTanetInfoAPI = () => {
  return CommonAPI.get(`/website/tenant`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

// export const getAllWebsiteInfoAPI = () => {
//   return CommonAPI.get(`/websites`)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       throw error.response;
//     });
// };

export const getAllWebsiteInfoAPI = () => {
  return CommonAPI.get(`/website/alltemplate`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteInfoAPI = (payload) => {
  return CommonAPI.put("/website", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postPrivacyPolicyAPI = (payload) => {
  return CommonAPI.post(
    `/website/privacy-policy?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updatePrivacyPolicyAPI = (payload) => {
  return CommonAPI.put(
    `/website/privacy-policy?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deletePrivacyPolicyAPI = (websiteId) => {
  return CommonAPI.delete(`/website/privacy-policy?websiteId=${websiteId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postTermsAndConditionAPI = (payload) => {
  return CommonAPI.post(
    `/website/terms-condition?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateTermsAndConditionAPI = (payload) => {
  return CommonAPI.put(
    `/website/terms-condition?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteTermsAndConditionAPI = (websiteId) => {
  return CommonAPI.delete(`/website/terms-condition?websiteId=${websiteId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteFaqAPI = (id) => {
  return CommonAPI.get(`/website/faq?id=${id || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getAllWebsiteFaqAPI = (websiteId) => {
  return CommonAPI.get(`/website/faq/all?websiteId=${websiteId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postWebsiteFaqAPI = (payload) => {
  return CommonAPI.post(
    `/website/faq?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteFaqAPI = (payload) => {
  return CommonAPI.put(
    `/website/faq?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteFaqAPI = (websiteId) => {
  return CommonAPI.delete(`/website/faq?websiteId=${websiteId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteFilterAPI = (id) => {
  return CommonAPI.get(`/website/filter?id=${id || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteFiltersAPI = (websiteId) => {
  return CommonAPI.get(`/website/filters?websiteId=${websiteId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postWebsiteFilterAPI = (payload) => {
  return CommonAPI.post(
    `/website/filter?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteFilterAPI = (payload) => {
  return CommonAPI.put("/website/filter", payload?.dto || payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteFilterAPI = (id) => {
  return CommonAPI.delete(`/website/filter?id=${id || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const multipWebsiteleFileUploadApi = async (payload) => {
  try {
    const formData = new FormData();

    payload.files.forEach((file) => {
      formData.append("files", file); // important
    });

    const response = await CommonAPI.post(`/website/child/upload/files`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// export const makeWebsiteActiveAPI = (payload) => {
//   return CommonAPI.put(`/website/active/${payload}`)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       throw error.response;
//     });
// };

export const makeWebsiteActiveAPI = (websiteTemplateID) => {
  return CommonAPI.put(`/website/active/${websiteTemplateID}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const createWebsiteInfoAPI = (payload) => {
  return CommonAPI.post("/website", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const publishWebsiteInfoAPI = (payload) => {
  return CommonAPI.post(`/tenants/publish/${payload}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postWebsiteChildAPI = (payload) => {
  return CommonAPI.post(
    `/website/child?websiteId=${payload?.websiteId || ""}`,
    payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteChildAPI = (payload) => {
  return CommonAPI.put(`/website/child`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteChildAPI = (WebsiteChildArrayId) => {
  return CommonAPI.delete(`/website/child/${WebsiteChildArrayId || null}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteOfferingAPI = (websiteId) => {
  return CommonAPI.get(`/website/offering?websiteId=${websiteId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postWebsiteOfferingAPI = (payload) => {
  return CommonAPI.post(
    `/website/offering?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteOfferingAPI = (payload) => {
  return CommonAPI.put("/website/offering", payload?.dto || payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteOfferingAPI = (id) => {
  return CommonAPI.delete(`/website/offering?id=${id || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteOfferingChildAPI = (websiteOfferingId) => {
  return CommonAPI.get(`/website/offering/child?websiteOfferingId=${websiteOfferingId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteOfferingChildByIdAPI = (websiteOfferingChildId) => {
  return CommonAPI.get(`/website/offering/child/${websiteOfferingChildId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getAllWebsiteOfferingChildAPI = () => {
  return CommonAPI.get("/website/offering/allchild")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postWebsiteOfferingChildAPI = (payload) => {
  return CommonAPI.post(
    `/website/offering/child?websiteOfferingId=${payload?.websiteOfferingId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteOfferingChildAPI = (payload) => {
  return CommonAPI.put("/website/offering/child", payload?.dto || payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteOfferingChildAPI = (websiteOfferingChildId) => {
  return CommonAPI.delete(`/website/offering/child/${websiteOfferingChildId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteOfferingChildFileAPI = (uploadId) => {
  return CommonAPI.delete(`/website/offering/child/file?uploadId=${uploadId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const uploadWebsiteOfferingChildFilesAPI = async (payload) => {
  try {
    const formData = new FormData();

    payload.files.forEach((file) => {
      formData.append("files", file);
    });

    const response = await CommonAPI.post("/website/offering/child/upload/files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getWebsiteSaleOfferAPI = (websiteId) => {
  return CommonAPI.get(`/website/sale-offer?websiteId=${websiteId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getAllWebsiteSaleOfferAPI = () => {
  return CommonAPI.get("/website/all/sale-offer")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postWebsiteSaleOfferAPI = (payload) => {
  return CommonAPI.post(
    `/website/sale-offer?websiteId=${payload?.websiteId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteSaleOfferAPI = (payload) => {
  return CommonAPI.put("/website/sale-offer", payload?.dto || payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteSaleOfferAPI = (id) => {
  return CommonAPI.delete(`/website/sale-offer?id=${id || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteSaleOfferChildAPI = (saleAndOfferId) => {
  return CommonAPI.get(`/website/sale-offer/child?saleAndOfferId=${saleAndOfferId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getWebsiteSaleOfferChildByIdAPI = (id) => {
  return CommonAPI.get(`/website/sale-offer/child/${id || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getAllWebsiteSaleOfferChildAPI = () => {
  return CommonAPI.get("/website/sale-offer/allchild")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const postWebsiteSaleOfferChildAPI = (payload) => {
  return CommonAPI.post(
    `/website/sale-offer/child?saleAndOfferId=${payload?.saleAndOfferId || ""}`,
    payload?.dto || payload,
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateWebsiteSaleOfferChildAPI = (payload) => {
  return CommonAPI.put("/website/sale-offer/child", payload?.dto || payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteSaleOfferChildAPI = (id) => {
  return CommonAPI.delete(`/website/sale-offer/child/${id || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const deleteWebsiteSaleOfferChildFileAPI = (uploadId) => {
  return CommonAPI.delete(`/website/sale-offer/child/file?uploadId=${uploadId || ""}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const uploadWebsiteSaleOfferChildFilesAPI = async (payload) => {
  try {
    const formData = new FormData();

    payload.files.forEach((file) => {
      formData.append("files", file);
    });

    const response = await CommonAPI.post("/website/sale-offer/child/upload/files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
